module.exports = __webpack_public_path__ + "static/img/Referenzen_big.4f500cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Referenzen_big.jpg
// module id = z1hB
// module chunks = 2